import { Route } from "@angular/router";
import { AuthGuard } from "../guards/auth.guard";
import { LayoutComponent } from "./layout/layout.component";

export const appRoutes: Route[] = [
    {
        path: "login",
        loadComponent: () => import("./pages/auth/login/login.page"),
    },
    {
        path: "",
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        children: [
            {
                path: "user",
                children: [
                    {
                        path: "",
                        loadComponent: () => import("./pages/user/user.page"),
                    },
                    {
                        path: ":id",
                        loadComponent: () =>
                            import("./pages/user/detail/user-detail.page"),
                    },
                ],
            },
            {
                path: "payment",
                children: [
                    {
                        path: "",
                        loadComponent: () =>
                            import("./pages/payment/payment.page"),
                    },
                    {
                        path: ":id",
                        loadComponent: () =>
                            import(
                                "./pages/payment/payment-detail/payment-detail.page"
                            ),
                    },
                ],
            },
            {
                path: "center",
                children: [
                    {
                        path: "",
                        loadComponent: () =>
                            import("./pages/center/center.page"),
                    },
                    {
                        path: "form",
                        loadComponent: () =>
                            import("./pages/center/form/center-form.page"),
                    },
                    {
                        path: ":id",
                        loadComponent: () =>
                            import("./pages/center/detail/center-detail.page"),
                    },
                ],
            },
            {
                path: "growth",
                children: [
                    {
                        path: "",
                        loadComponent: () =>
                            import("./pages/growth-center/growth-center.page"),
                    },
                    {
                        path: ":id",
                        loadComponent: () =>
                            import(
                                "./pages/growth-center/growth-center-detail/growth-center-detail.page"
                            ),
                    },
                ],
            },
            {
                path: "voucher",
                children: [
                    {
                        path: "",
                        loadComponent: () =>
                            import("./pages/task/voucher/voucher.page"),
                    },
                    {
                        path: "form",
                        loadComponent: () =>
                            import(
                                "./pages/task/voucher/voucher-form/voucher-form.page"
                            ),
                    },
                    {
                        path: ":id",
                        loadComponent: () =>
                            import(
                                "./pages/task/voucher/voucher-detail/voucher-detail.page"
                            ),
                    },
                ],
            },
            {
                path: "inspection-data-category",
                children: [
                    {
                        path: "",
                        loadComponent: () =>
                            import(
                                "./pages/task/inspection-data-category/inspection-data-category.page"
                            ),
                    },
                ],
            },
            {
                path: "coupon",
                children: [
                    {
                        path: "member-coupon",
                        children: [
                            {
                                path: "",
                                loadComponent: () =>
                                    import(
                                        "./pages/member-coupon/member-coupon.page"
                                    ),
                            },
                            {
                                path: ":id",
                                loadComponent: () =>
                                    import(
                                        "./pages/member-coupon/member-coupon-detail/member-coupon-detail.page"
                                    ),
                            },
                        ],
                    },
                    {
                        path: "auto-issued-coupon",
                        children: [
                            {
                                path: "",
                                loadComponent: () =>
                                    import(
                                        "./pages/auto-issued-coupon/auto-issued-coupon.page"
                                    ),
                            },
                            {
                                path: ":id",
                                loadComponent: () =>
                                    import(
                                        "./pages/auto-issued-coupon/auto-issued-coupon-detail/auto-issued-coupon-detail.page"
                                    ),
                            },
                        ],
                    },
                    {
                        path: "coupon-usage-history",
                        children: [
                            {
                                path: "",
                                loadComponent: () =>
                                    import(
                                        "./pages/coupon-usage-history/coupon-usage-history.page"
                                    ),
                            },
                        ],
                    },
                    {
                        path: "",
                        loadComponent: () =>
                            import("./pages/coupon/coupon.page"),
                    },
                    {
                        path: ":id",
                        loadComponent: () =>
                            import(
                                "./pages/coupon/group-coupon-detail/group-coupon-detail.page"
                            ),
                    },
                ],
            },
            {
                path: "ticket-type",
                children: [
                    {
                        path: "",
                        loadComponent: () =>
                            import("./pages/task/ticket-type/ticket-type.page"),
                    },
                ],
            },
            {
                path: "document",
                children: [
                    {
                        path: "",
                        loadComponent: () =>
                            import("./pages/task/document/document.page"),
                    },
                    {
                        path: "form",
                        loadComponent: () =>
                            import(
                                "./pages/task/document/document-form/document-form.page"
                            ),
                    },
                    {
                        path: ":id",
                        loadComponent: () =>
                            import(
                                "./pages/task/document/document-detail/document-detail.page"
                            ),
                    },
                ],
            },
            {
                path: "store",
                children: [
                    {
                        path: "detail/:productId",
                        loadComponent: () =>
                            import(
                                "./pages/store/product-detail/product-detail.page"
                            ),
                    },
                    {
                        path: "form/:type",
                        loadComponent: () =>
                            import(
                                "./pages/store/product-form/product-form.page"
                            ),
                    },
                    {
                        path: ":type",
                        loadComponent: () =>
                            import("./pages/store/product.page"),
                    },
                ],
            },
            {
                path: "child",
                children: [
                    {
                        path: "",
                        loadComponent: () => import("./pages/child/child.page"),
                    },
                    {
                        path: "form",
                        loadComponent: () =>
                            import(
                                "./pages/child/create-child/create-child.page"
                            ),
                    },
                    {
                        path: ":id",
                        loadComponent: () =>
                            import(
                                "./pages/child/child-detail/child-detail.page"
                            ),
                    },
                ],
            },
            {
                path: "content-category",
                loadComponent: () =>
                    import(
                        "./pages/content/content-category/content-category.page"
                    ),
            },
            {
                path: "content",
                children: [
                    {
                        path: "",
                        loadComponent: () =>
                            import("./pages/content/content.page"),
                    },
                    {
                        path: "form",
                        loadComponent: () =>
                            import(
                                "./pages/content/content-form/content-form.page"
                            ),
                    },
                    {
                        path: ":id",
                        loadComponent: () =>
                            import(
                                "./pages/content/content-detail/content-detail.page"
                            ),
                    },
                ],
            },
            {
                path: "teacher",
                children: [
                    {
                        path: "notice",
                        children: [
                            {
                                path: "",
                                loadComponent: () =>
                                    import(
                                        "./pages/customer/notice/notice.page"
                                    ),
                            },
                            {
                                path: "create",
                                loadComponent: () =>
                                    import(
                                        "./pages/customer/notice/create-notice/create-notice.page"
                                    ),
                            },
                            {
                                path: "update",
                                children: [
                                    {
                                        path: ":id",
                                        loadComponent: () =>
                                            import(
                                                "./pages/customer/notice/create-notice/create-notice.page"
                                            ),
                                    },
                                ],
                            },
                            {
                                path: ":id",
                                children: [
                                    {
                                        path: "",
                                        loadComponent: () =>
                                            import(
                                                "./pages/customer/notice/detail-notice/detail-notice.page"
                                            ),
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        path: "inquiry",
                        children: [
                            {
                                path: "",
                                loadComponent: () =>
                                    import(
                                        "./pages/customer/inquiry/inquiry.page"
                                    ),
                            },
                            {
                                path: ":id",
                                children: [
                                    {
                                        path: "",
                                        loadComponent: () =>
                                            import(
                                                "./pages/customer/inquiry/detail-inquiry/detail-inquiry.page"
                                            ),
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        path: "faq",
                        children: [
                            {
                                path: "",
                                loadComponent: () =>
                                    import("./pages/customer/faq/faq.page"),
                            },
                            {
                                path: "create",
                                loadComponent: () =>
                                    import(
                                        "./pages/customer/faq/create-faq/create-faq.page"
                                    ),
                            },
                            {
                                path: "update",
                                children: [
                                    {
                                        path: ":id",
                                        loadComponent: () =>
                                            import(
                                                "./pages/customer/faq/create-faq/create-faq.page"
                                            ),
                                    },
                                ],
                            },
                            {
                                path: ":id",
                                loadComponent: () =>
                                    import(
                                        "./pages/customer/faq/detail-faq/detail-faq.page"
                                    ),
                            },
                        ],
                    },
                ],
            },
            {
                path: "parent",
                children: [
                    {
                        path: "notice",
                        children: [
                            {
                                path: "",
                                loadComponent: () =>
                                    import(
                                        "./pages/customer/notice/notice.page"
                                    ),
                            },
                            {
                                path: "create",
                                loadComponent: () =>
                                    import(
                                        "./pages/customer/notice/create-notice/create-notice.page"
                                    ),
                            },
                            {
                                path: "update",
                                children: [
                                    {
                                        path: ":id",
                                        loadComponent: () =>
                                            import(
                                                "./pages/customer/notice/create-notice/create-notice.page"
                                            ),
                                    },
                                ],
                            },
                            {
                                path: ":id",
                                children: [
                                    {
                                        path: "",
                                        loadComponent: () =>
                                            import(
                                                "./pages/customer/notice/detail-notice/detail-notice.page"
                                            ),
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        path: "inquiry",
                        children: [
                            {
                                path: "",
                                loadComponent: () =>
                                    import(
                                        "./pages/customer/inquiry/inquiry.page"
                                    ),
                            },
                            {
                                path: ":id",
                                children: [
                                    {
                                        path: "",
                                        loadComponent: () =>
                                            import(
                                                "./pages/customer/inquiry/detail-inquiry/detail-inquiry.page"
                                            ),
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        path: "faq",
                        children: [
                            {
                                path: "",
                                loadComponent: () =>
                                    import("./pages/customer/faq/faq.page"),
                            },
                            {
                                path: "create",
                                loadComponent: () =>
                                    import(
                                        "./pages/customer/faq/create-faq/create-faq.page"
                                    ),
                            },
                            {
                                path: "update",
                                children: [
                                    {
                                        path: ":id",
                                        loadComponent: () =>
                                            import(
                                                "./pages/customer/faq/create-faq/create-faq.page"
                                            ),
                                    },
                                ],
                            },
                            {
                                path: ":id",
                                loadComponent: () =>
                                    import(
                                        "./pages/customer/faq/detail-faq/detail-faq.page"
                                    ),
                            },
                        ],
                    },
                ],
            },
            {
                path: "term",
                loadComponent: () => import("./pages/info/term/term.page"),
            },
            {
                path: "company-info",
                loadComponent: () =>
                    import("./pages/info/company-info/company-info.page"),
            },

            {
                path: "admin",
                children: [
                    {
                        path: "",
                        loadComponent: () => import("./pages/admin/admin.page"),
                    },
                    {
                        path: "form",
                        loadComponent: () =>
                            import("./pages/admin/admin-form/admin-form.page"),
                    },
                    {
                        path: ":id",
                        loadComponent: () =>
                            import(
                                "./pages/admin/admin-detail/admin-detail.page"
                            ),
                    },
                ],
            },
            {
                path: "popup",
                children: [
                    {
                        path: "",
                        loadComponent: () => import("./pages/popup/popup.page"),
                    },
                    {
                        path: "form",
                        children: [
                            {
                                path: "",
                                loadComponent: () =>
                                    import(
                                        "./pages/popup/popup-form/popup-form.page"
                                    ),
                            },
                            {
                                path: ":id",
                                loadComponent: () =>
                                    import(
                                        "./pages/popup/popup-form/popup-form.page"
                                    ),
                            },
                        ],
                    },
                    {
                        path: ":id",
                        loadComponent: () =>
                            import(
                                "./pages/popup/popup-detail/popup-detail.page"
                            ),
                    },
                ],
            },
            {
                path: "ad",
                children: [
                    {
                        path: "form",
                        children: [
                            {
                                path: "",
                                loadComponent: () =>
                                    import("./pages/ad/ad-form/ad-form.page"),
                            },
                            {
                                path: ":id",
                                loadComponent: () =>
                                    import("./pages/ad/ad-form/ad-form.page"),
                            },
                        ],
                    },
                    {
                        path: "",
                        loadComponent: () => import("./pages/ad/ad.page"),
                    },
                    {
                        path: ":id",
                        loadComponent: () =>
                            import("./pages/ad/ad-detail/ad-detail.page"),
                    },
                ],
            },
            {
                path: "inspection",
                children: [
                    {
                        path: "",
                        loadComponent: () =>
                            import("./pages/inspection/inspection.page"),
                    },
                    {
                        path: ":id",
                        loadComponent: () =>
                            import(
                                "./pages/inspection/inspection-detail/inspection-detail.page"
                            ),
                    },
                ],
            },
        ],
    },
    {
        path: "**",
        redirectTo: "",
        pathMatch: "full",
    },
];
